import './style.scss';

interface SpinnerProps {
  wrapInContainer?: boolean;
}

export default function Spinner({ wrapInContainer }: SpinnerProps) {
  const RenderAnimation = () => {
    return (
      <div className="loading-animation">
        <div className="loader-container arc-rotate2">
          <div className="loader">
            <div className="arc" />
          </div>
        </div>
      </div>
    );
  };

  if (wrapInContainer) {
    return (
      <div className="loading-animation-container">
        <RenderAnimation />
      </div>
    );
  }

  return <RenderAnimation />;
}
